import babbelTracker from '@lessonnine/tracker.js'
import { TRACKING_URL, UUID } from 'src/dataLayer/env'

const TRACKING_UUID_NAME = 'babbeltrackinguuid'

const tracker = new babbelTracker.Tracker({
  defaultPayload: {},
  trackingUuidName: TRACKING_UUID_NAME,
  url: TRACKING_URL,
  userUuid: UUID,
})

export default tracker.track
